import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule,
} from '@domain-group/suit-theme'

import useBrandTheme from '@hooks/useBrandTheme'
import useBrandThemes from '@hooks/useBrandThemes'

import BrandThemeListItem from './BrandThemeListItem'

const BrandThemes = (props) => {
  const { brand } = props

  const brandThemePayload = useBrandTheme({ brand_id: brand.id })
  const {
    callbacks: {
      createOrEditBrandTheme,
    },
  } = brandThemePayload

  const brandThemesPayload = useBrandThemes({
    filters: { brand_id: brand.id },
    performHttpRequests: !!brand.id,
  })

  const {
    filteredBrandThemes,
    hasFilteredBrandThemes,
    loading,
  } = brandThemesPayload

  return (
    <DashboardModule loading={loading} title="Brand Themes">
      <Box flexDirection="column">
        <DashboardModule.ScrollableSection>
          {!loading && filteredBrandThemes.map(brandTheme => (
            <BrandThemeListItem key={brandTheme.id} brandTheme={brandTheme} />
          ))}
        </DashboardModule.ScrollableSection>

        <DashboardModule.Footer
          boxProps={{ borderTop: hasFilteredBrandThemes ? '1px solid' : 'none' }}
        >
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditBrandTheme()}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Theme
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

BrandThemes.propTypes = {
  brand: PropTypes.object.isRequired,
}

export default BrandThemes
